<header class="dialog-header">
  <h3 class="header-heading">
    <span [ngClass]="form.get('cardType').value">
      <i [ngClass]="cardIcon"></i>
      {{ cardLabel }}
    </span>
    <span class="heading-text">{{ 'pages.user-cards.link.heading' | translate }}</span>
  </h3>
  <button mat-icon-button class="close-icon" aria-label="Close" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
</header>

<div class="dialog-content">
  <!-- Form Section — hidden when search result or loading is shown -->
  <div *ngIf="!useSearchFlow || (!searchResult && !searchLoading)" [formGroup]="form">
    <app-form-input
      label="{{ 'pages.user-cards.link.label' | translate }}"
      [messages]="true"
      formControlName="cardNumber"
      data-cy="cardNumber">
    </app-form-input>
  </div>

  <!-- Search Results -->
  <ng-container *ngIf="useSearchFlow && searchResult">

    <!-- CARD_NOT_YOURS -->
    <div *ngIf="searchResult.status === 'CARD_NOT_YOURS'" class="search-result-status">
      <div class="search-result-icon amber">
        <mat-icon>warning</mat-icon>
      </div>
      <h3>{{ 'pages.user-cards.search.notYours.title' | translate }}</h3>
      <p>{{ 'pages.user-cards.search.notYours.message' | translate }}</p>
      <p class="card-number" *ngIf="searchResult.card?.number || searchResult.card?.code">{{ 'pages.user-cards.search.cardNumber' | translate }} {{ searchResult.card?.code || searchResult.card?.number }}</p>
      <button class="bciti-button bciti-button--blue" (click)="resetSearch()">
        {{ 'pages.user-cards.search.tryAgain' | translate }}
      </button>
    </div>

    <!-- ALTERNATIVE_FOUND -->
    <div *ngIf="searchResult.status === 'ALTERNATIVE_FOUND'" class="search-result-status">
      <div class="search-result-icon amber">
        <mat-icon>auto_awesome</mat-icon>
      </div>
      <h3>{{ 'pages.user-cards.search.alternativeFound.title' | translate }}</h3>
      <p>{{ 'pages.user-cards.search.alternativeFound.message' | translate }}</p>
      <p class="card-number">{{ 'pages.user-cards.search.cardNumber' | translate }} {{ searchResult.card?.code || searchResult.card?.number }}</p>
      <button class="bciti-button bciti-button--blue" (click)="confirmAlternativeCard()">
        {{ 'pages.user-cards.search.alternativeFound.confirm' | translate }}
      </button>
      <a class="text-link" (click)="resetSearch()">{{ 'pages.user-cards.search.tryDifferentNumber' | translate }}</a>
    </div>

    <!-- NOT_FOUND -->
    <div *ngIf="searchResult.status === 'NOT_FOUND'" class="search-result-status">
      <div class="search-result-icon amber">
        <mat-icon>search_off</mat-icon>
      </div>
      <h3>{{ 'pages.user-cards.search.notFound.title' | translate }}</h3>
      <p>{{ 'pages.user-cards.search.notFound.message' | translate }}</p>
      <button class="bciti-button bciti-button--blue" (click)="resetSearch()">
        {{ 'pages.user-cards.search.tryAgain' | translate }}
      </button>
    </div>

    <!-- ALREADY_LINKED -->
    <div *ngIf="searchResult.status === 'ALREADY_LINKED'" class="search-result-status">
      <div class="search-result-icon error">
        <mat-icon>warning</mat-icon>
      </div>
      <h3>{{ 'pages.user-cards.search.alreadyLinked.title' | translate }}</h3>
      <p>{{ 'pages.user-cards.search.alreadyLinked.message' | translate:{ email: searchResult.linkedToEmail } }}</p>
      <p *ngIf="searchResult.card?.number || searchResult.card?.code" class="card-number">{{ 'pages.user-cards.search.cardNumber' | translate }} {{ searchResult.card?.code || searchResult.card?.number }}</p>
      <button class="bciti-button bciti-button--blue" (click)="closeDialog()">
        {{ 'pages.user-cards.common.button.close' | translate }}
      </button>
    </div>

  </ng-container>

  <!-- Search Loading -->
  <div *ngIf="useSearchFlow && searchLoading" class="search-loading">
    <mat-spinner diameter="40"></mat-spinner>
    <p>{{ 'pages.user-cards.search.verifying' | translate }}</p>
  </div>
</div>

<footer class="dialog-footer" *ngIf="!useSearchFlow || (!searchResult && !searchLoading)">
  <button
    (click)="closeDialog()"
    class="bciti-inline-button back-button">
    {{ 'pages.user-cards.common.button.close' | translate }}
  </button>
  <div class="spacer"></div>
  <button
    [disabled]="!validateCardLinkForm() || processingSubmit"
    [ngClass]="validateCardLinkForm() ? 'bciti-button--blue' : 'bciti-button--red'"
    (click)="submit()"
    class="bciti-button next-button">
    <span *ngIf="!processingSubmit">{{ 'pages.user-cards.common.button.submit' | translate }}</span>
    <mat-spinner *ngIf="processingSubmit" diameter="20"></mat-spinner>
  </button>
</footer>
